import request, { gql } from "graphql-request";
import { useState, useEffect ,useRef} from "react";
import { createContext } from "react";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  AllCustomerDataByMasterQuery,
  AllCustomerDataByUserQuery,
  AllCustomerDetailsQuery,
  getLeadprospectDetailByUser,
} from "../../lib/graphQL/graphQuery";
import { useContext } from "react";
import { useAuth } from "../AuthContext/AuthContextProvider";

export const MyCustomerContext = createContext();

export default function CustomerContext({ children }) {
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const { currentUser, authenticated } = useAuth();
  const isUser = currentUser?.role;
  const pdfRef = useRef();
  const [rowdata,setrowdata] = useState('')
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (authenticated) {
      fetchCustomerData();
    }
  }, []);
  const fetchCustomerData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser == "manager"
        ? AllCustomerDataByMasterQuery
        : isUser?.toLowerCase() == "employee"
        ? AllCustomerDataByUserQuery
        : isUser?.toLowerCase() == "superuser"
        ? AllCustomerDetailsQuery
        : "Data Not Found",
      { id: currentUser?.id }
    )
      .then((res) => {
      
        setCustomerData(
          isUser?.toLowerCase() == "manager"
            ? res.getCustomerdetailByMaster
            : isUser?.toLowerCase() == "employee"
            ? res.getCustomerdetailByUser
            : isUser?.toLowerCase() == "superuser"
            ? res.allCustomer
            : []
        );
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <MyCustomerContext.Provider
      value={{
        customerData,
        setCustomerData,
        isLoading,
        setIsLoading,
        status,
        setStatus,
        pdfRef,
        rowdata,setrowdata,
        showModal, setShowModal,
        fetchCustomerData
      }}
    >
      {children}
    </MyCustomerContext.Provider>
  );
}

export const useCustomer = () => {
  return useContext(MyCustomerContext);
};
